import { cloneDeep } from 'lodash';
import RetencionBaseRequestInputTransformer from './requests/RetencionBaseRequestInputTransformer';
import PlataformasTecnologicasRequestInputTransformer from './requests/PlataformasTecnologicasRequestInputTransformer';
import FideicomisoNoEmpresarialRequestInputTransformer from './requests/FideicomisoNoEmpresarialRequestInputTransformer';

class RetencionesRequestInputTransformer {
  strategies = {};

  boot() {
    this.register(new FideicomisoNoEmpresarialRequestInputTransformer());
    this.register(new PlataformasTecnologicasRequestInputTransformer());
    this.register(new RetencionBaseRequestInputTransformer());

    return this;
  }

  register(transformer) {
    this.strategies[transformer.getName()] = transformer;

    return this;
  }

  apply(data) {
    for (const strategy of Object.values(this.strategies)) {
      data = strategy.make(data);
    }

    return data;
  }

  static make(data) {
    data = cloneDeep(data);

    const newThis = new this();

    return newThis.boot().apply(data);
  }
}

export default RetencionesRequestInputTransformer;
